import { Component, OnInit } from '@angular/core';
import { BaseListCtl } from '../common/base-list.component';
import { ServiceLocatorService } from '../common/service/service-locator.service';
import { ActivatedRoute } from '../../../node_modules/@angular/router';
import { GlobalConstants } from '../common/GlobalConstants ';

@Component({
  selector: 'app-event-list',
  templateUrl: './event-list.component.html',
  styleUrls: ['./event-list.component.css']
})
export class EventListComponent extends BaseListCtl {

  constructor(public locator: ServiceLocatorService, public route: ActivatedRoute) {
    super(locator.endpoints.EVENT,locator,route);
   }

   public sid = localStorage.getItem( GlobalConstants.getKey('sessionId'));

   populateForm(form, data) {
    form.id = data.id;
    form.name = data.name;
    form.qrCode = data.qrCode;
    form.unitId = data.unitId;
    form.unitName = data.unitName;
    form.wifiName = data.wifiName;
    form.userId = data.userId;
    form.userName = data.userName;
    form.latitude = data.latitude;
    form.longitude = data.longitude;
    form.mobileId = data.mobileId;
    form.isWifi = data.isWifi;
    form.accessRequest = data.accessRequest;
    form.status = data.status;  
    console.log('----->',data);
  }

  getQRCodeHref(qrCode){
    if(qrCode){
      qrCode = qrCode.trim();
    }
    let url = "http://nenosystems.com:9099/PNAC/Event/qrcode/" + qrCode +';jsessionid='+ this.sid
    return url;
  }

}
